import React, { useState, useRef, useEffect } from 'react';
import { FaUser, FaBox, FaSignOutAlt } from 'react-icons/fa';
import user from "../../Assets/images/userProfile.webp";
import { useNavigate } from 'react-router';
import toast from 'react-hot-toast';
import { removeItemFromStorage } from '../../lib/storage';
import { getProfile } from '../../api/profileService';
import { logout } from '../../api/loginUser';

const ProfileDropdown = ({ setMenuOpen, setStep }) => {
  const [open, setOpen] = useState(false);
  const [profile, setProfile] = useState(null);
  const [logoutLoading, setLogoutLoading] = useState(false);
    const fetchProfile = async () => {
      try {
        const res = await getProfile();
        const profiledetail = res?.responsePacket;
        setProfile(res?.responsePacket);
          const isProfileIncomplete =
        !profiledetail?.firstName ||
        !profiledetail?.email ||
        !profiledetail?.mobile;
        if (isProfileIncomplete) {
          localStorage.setItem("personalInfoCompleted", "false");
        } else {
          localStorage.setItem("personalInfoCompleted", "true");
        }

      } catch (err) {
        const token = localStorage.getItem("lmsCCToken");
        if (!token) {
          toast.error("Session expired. Please log in again.");
          removeItemFromStorage("lmsCCToken");
          navigate('/');
          setStep("login")
        }
        console.error("Error fetching profile in dropdown:", err);
      }
    };

  useEffect(() => {
    fetchProfile();
    window.addEventListener("profileUpdated", fetchProfile);
    return () => window.removeEventListener("profileUpdated", fetchProfile);
  }, []);

  const dropdownRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      setLogoutLoading(true);
      const res = await logout();
      if (res?.errorCode === 0) {
        removeItemFromStorage("lmsCCToken");
        removeItemFromStorage("lmsCCUser");
        window.dispatchEvent(new Event("userLoggedOut"));
        toast.success("Logged Out Successfully");
        navigate("/");
        setStep("login");
      } else {
        toast.error("Logout failed, please try again");
      }
    } catch (err) {
      console.error("Error during logout:", err);
      toast.error("Something went wrong during logout");
    } finally {
      setLogoutLoading(false);
    }
  };

  return (
    <div onClick={() => setMenuOpen(false)} className="relative" ref={dropdownRef}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 border px-4 py-1 rounded-full hover:shadow"
      >
        <img
          src={profile?.photoImageUrl || user}
          alt="User"
          className="w-8 h-8 rounded-full object-cover"
        />
        <span>{profile?.firstName} {profile?.lastName}</span>
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 bg-white rounded-lg shadow-lg z-50 text-sm">
          <div className="divide-y">
            <ul className="p-1 space-y-1 text-gray-700 min-w-[180px]">
              <li
                className="flex items-center gap-2 px-2 py-1 hover:bg-gray-100 rounded cursor-pointer"
                onClick={() =>
                  {navigate("/MyProfilePage", { state: { profileData: profile } })
                setOpen(false);
                }
                }
              >
                <FaUser /> My Profile
              </li>
              <li
                onClick={() =>{ navigate("/OrderDetailsPage")
                setOpen(false);
                }}
                className="flex items-center gap-2 px-2 py-1 hover:bg-gray-100 rounded cursor-pointer"
              >
                <FaBox /> Order Details
              </li>
            </ul>
            <div className="p-1">
              <button
                onClick={handleLogout}
                disabled={logoutLoading}
                className={`flex items-center gap-2 w-full text-left px-2 py-1 rounded ${
                  logoutLoading
                    ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                    : "hover:bg-gray-100 text-red-600"
                }`}
              >
                {logoutLoading ? (
                  <span className="animate-spin w-4 h-4 border-2 border-red-500 border-t-transparent rounded-full"></span>
                ) : (
                  <FaSignOutAlt />
                )}
                {logoutLoading ? "Logging out..." : "Log Out"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;
